import React, { useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
//CSS
import './style.css';
//
export default function Error(props){
    const [code] = useState(props.error || '404');
    console.log(props);
    //
    //Renders
    const getPage = () => {
        let content = (<></>);
        switch(code){
            case '404':
                content = (
                    <div className="error-content text-center text-white">
                        <div className="notfound-404">
                            <h1 className="text-white">404</h1>
                        </div>
                        <h3 className="text-white">Desculpe, acho que nos perdemos.</h3>
                        <p>Vamos tentar nos encontrar de novo?</p>
                        <a className="btn app-store-btn" href="/">Voltar à Home</a>
                    </div>
                );
                break;
            default:
                content = (
                    <div className="error-content text-center text-white">
                        <div className="notfound-404">
                            <h1 className="text-white">:(</h1>
                        </div>
                        <h3 className="text-white">Desculpe, não sabemos o que houve.</h3>
                        <p>Vamos tentar nos encontrar de novo?</p>
                        <a className="btn app-store-btn" href="/">Voltar à Home</a>
                    </div>
                );
        }
        return(
            <>
                { content }
            </>
        );
    }
    return(
        <section className="hero-section pt-5 pb-5 background-img full-screen">
            <Container>
                <Row className="align-items-center justify-content-center">
                    <Col className="col-md-9 col-lg-7">
                        { getPage() }
                    </Col>
                </Row>
            </Container>
        </section>
    );
}